import * as React from 'react'
import classNames from 'classnames'

import type { LinkType } from 'types'
import type { Props as CardProps } from './LocationCourseCard'

import Button from 'content-components/_Primatives/Button'
import Loader from 'content-components/_Primatives/Loader'
import LocationCourseCard from './LocationCourseCard'

import style from './style.scss'

type Props = {
  cards?: CardProps[]
  className?: string
  findCourseLink: LinkType
  isLoading: boolean
}

function LocationCourseCards(props: Props) {
  const { className, cards = [], findCourseLink, isLoading } = props
  const { text, url, target } = findCourseLink

  return isLoading ? (
    <Loader />
  ) : (
    <div className={classNames(style.wrapper, className)}>
      {cards.length > 0 && (
        <div className={style.cardContainer}>
          {cards.map((card) => (
            <LocationCourseCard key={card.link.url} {...card} />
          ))}
        </div>
      )}
      <Button target={target} url={url} variant='primaryBlue'>
        {text}
      </Button>
    </div>
  )
}

export default LocationCourseCards
